var map = {
	"./AmirRahimi.png": 539,
	"./close_FILL0_wght400_GRAD0_opsz48.svg": 442,
	"./focalized.jpg": 277,
	"./frosty.jpg": 410,
	"./hoosh.jpg": 43,
	"./iwingaming.jpg": 456,
	"./open_in_new.svg": 959,
	"./project2.png": 54,
	"./qoutebackground.png": 672,
	"./quote.svg": 855,
	"./wheelwish.jpg": 295
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 303;